// @flow

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

class EnabledDisabledIcon extends Component {

  static propTypes = {
    value: PropTypes.bool.isRequired,

    isDisable: PropTypes.bool,

    placeholder: PropTypes.string,

    style: PropTypes.object
  };

  static defaultProps = {
    isDisable: false,

    style: null
  };

  shouldComponentUpdate(nextProps) {
    return this.props.value !== nextProps.value || this.props.isDisable !== nextProps.isDisable;
  }

  get value() {
    return this.props.value;
  }

  render() {
    const className = classNames('enabled_disabled_icon', {
      enabled: this.value === true,
      disabled: this.value === false,
      force_disabled: this.props.isDisable === true
    });

    return (
      <span
        data-toggle="tooltip"
        data-title={this.props.placeholder}
        className={className}
        style={this.props.style}
      >
      </span>
    );
  }

}

export default EnabledDisabledIcon;
